import { connectHook } from '../../connect-hook.js';
import { SelectQuery } from './select-query.js';
import { useSelectQuery } from './select-query-hook.js';

export default connectHook(SelectQuery, useSelectQuery);
